const PAYMENTS = {
  PAYMENTS: '/payments',
  SUBSCRIPTION: {
    SUBSCRIPTION: '/payments/subscription',
    RETRY: '/payments/subscription/retry'
  }
}

export default PAYMENTS
